export interface MessageListItem {
  _id: string;
  direction: "SENT" | "RECEIVED";
  status: MessageStatusValue;
  recipient: string | null;
  sender: string | null;
  body: string;
  segments: number;
  deviceId: string | null;
  failureCode: string | null;
  failureReason: string | null;
  createdAt: string;
  sentAt: string | null;
  deliveredAt: string | null;
  scheduledAt?: string | null;
  queuedAt?: string | null;
  sendingAt?: string | null;
  batchId?: string | null;
}

export type MessageStatusValue =
  | "PENDING"
  | "QUEUED"
  | "SENDING"
  | "SENT"
  | "DELIVERED"
  | "FAILED"
  | "CANCELLED";

export interface CursorPageOf<T> {
  items: T[];
  nextCursor: string | null;
  hasMore: boolean;
  /**
   * Total matching rows, reported by the server alongside the page. Optional so older callers
   * keep compiling; where present it is what lets pagination show "x / y" and enable a real
   * jump-to-last on a keyset list.
   */
  total?: number;
}

/** Only pre-transmission states can be pulled back — mirrors the server's cancel guard. */
export const CANCELLABLE: MessageStatusValue[] = ["PENDING", "QUEUED"];
export const RETRYABLE: MessageStatusValue[] = ["FAILED", "CANCELLED"];

export function formatWhen(value: string | null | undefined): string {
  if (!value) return "—";
  return new Date(value).toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** Turns the server's failure_code enum into something a human can act on. */
export const FAILURE_EXPLANATION: Record<string, string> = {
  no_device_online: "No enabled Android device is paired to this account.",
  pickup_timeout: "No device picked the message up within 90 seconds.",
  sending_timeout:
    "The device claimed the message but never reported a result.",
  carrier_rejected: "The mobile carrier rejected the message.",
  invalid_number: "The recipient number was rejected as invalid.",
  opted_out: "This recipient has opted out of receiving messages.",
  unknown: "The device reported a failure without a specific reason.",
};
